import { ChannelV2 } from "./v2";

export const channelOptions = Object.entries(ChannelV2)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
